let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g5hZP")).then(() => parcelRequire('dMIKG'));